module.exports = __webpack_public_path__ + "static/media/button-google-play@2x.96276258.png";